export default {
    lang: {
        name: 'nl-be',
        weekdays: [
            "zondag",
            "maandag",
            "dinsdag",
            "woensdag",
            "donderdag",
            "vrijdag",
            "zaterdag"
        ],
        weekdaysShort: ['zo.', 'ma.', 'di.', 'wo.', 'do.', 'vr.', 'za.'],
        weekStart: 1,
        months: [
            "januari",
            "februari",
            "maart",
            "april",
            "mei",
            "juni",
            "juli",
            "augustus",
            "september",
            "oktober",
            "november",
            "december"
        ],
        monthsShort: [
            "jan.",
            "feb.",
            "mrt.",
            "apr.",
            "mei",
            "jun.",
            "jul.",
            "aug.",
            "sep.",
            "okt.",
            "nov.",
            "dec."
        ],
        formats: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        ordinal: n => n,
        buttonCancel: 'Annuleren',
        buttonValidate: 'Ok',
        rangeHeaderText: 'Van %d tot 13',
    },
}